export default "__VITE_PUBLIC_ASSET__87ecab0a__"